const tr = {
  a11yVideoLabelText: "Yüz canlılık kontrolünü gösteren video",
  cameraMinSpecificationsHeadingText: "Kamera minimum gereksinimleri",
  cameraMinSpecificationsMessageText:
    "Lütfen kameranızın canlılık kontrolü için gereken minimum gereksinimleri karşıladığından emin olun.",
  cameraNotFoundHeadingText: "Kamera bulunamadı",
  cameraNotFoundMessageText:
    "Kamera algılanamadı. Lütfen kameranızın bağlı olduğundan emin olun ve tekrar deneyin.",
  cancelLivenessCheckText: "Canlılık kontrolünü iptal et",
  clientHeaderText: "Müşteri mesajı",
  clientMessageText:
    "Lütfen yüz canlılık kontrolünü tamamlamak için ekrandaki talimatları izleyin.",
  connectionTimeoutHeaderText: "Bağlantı zaman aşımı",
  connectionTimeoutMessageText:
    "Bağlantı zaman aşımına uğradı. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.",
  errorLabelText: "Hata",
  faceDistanceHeaderText: "Yüz mesafesi",
  faceDistanceMessageText:
    "Lütfen yüzünüzün kameraya doğru mesafede olduğundan emin olun.",
  goodFitAltText: "Yüz düzgün hizalanmış",
  goodFitCaptionText: "Yüzünüz düzgün hizalanmış. Lütfen hareketsiz kalın.",
  hintCanNotIdentifyText: "Yüz tanımlanamıyor. Lütfen tekrar deneyin.",
  hintCenterFaceInstructionText: "Yüzünüzü çerçevenin ortasına yerleştirin.",
  hintCenterFaceText: "Yüzünüzü ortalayın",
  hintCheckCompleteText: "Kontrol tamamlandı",
  hintConnectingText: "Bağlanıyor...",
  hintFaceDetectedText: "Yüz algılandı",
  hintFaceOffCenterText: "Yüzünüz ortalanmamış. Lütfen ayarlayın.",
  hintHoldFaceForFreshnessText: "Kontrol için yüzünüzü sabit tutun.",
  hintIlluminationNormalText: "Aydınlatma iyi",
  hintIlluminationTooBrightText: "Aydınlatma çok parlak",
  hintIlluminationTooDarkText: "Aydınlatma çok karanlık",
  hintMatchIndicatorText: "Yüz göstergeleri karşılaştırılıyor...",
  hintMoveFaceFrontOfCameraText: "Yüzünüzü kameranın önüne getirin",
  hintTooCloseText: "Kameraya çok yakınsınız",
  hintTooFarText: "Kameradan çok uzaksınız",
  hintTooManyFacesText:
    "Çok fazla yüz algılandı. Çerçevede yalnızca bir yüz olmalıdır.",
  hintVerifyingText: "Doğrulanıyor...",
  landscapeHeaderText: "Yatay mod algılandı",
  landscapeMessageText: "Canlılık kontrolü için lütfen dikey moda geçin.",
  multipleFacesHeaderText: "Birden fazla yüz algılandı",
  multipleFacesMessageText:
    "Çerçevede yalnızca bir yüz olmalıdır. Lütfen ayarlayın ve tekrar deneyin.",
  photosensitivityWarningBodyText:
    "Bu kontrol bir dizi görsel uyaran içerir. Işık hassasiyeti sorunlarınız varsa lütfen dikkatli ilerleyin.",
  photosensitivityWarningHeadingText: "Işık hassasiyeti uyarısı",
  photosensitivityWarningInfoText:
    "Rahatsızlık hissederseniz kontrolü istediğiniz zaman durdurabilirsiniz.",
  photosensitivityWarningLabelText: "Riskleri anlıyorum",
  portraitMessageText: "Lütfen cihazınızı dikey modda tutun.",
  recordingIndicatorText: "Kayıt devam ediyor",
  retryCameraPermissionsText: "Kamera izinlerini yeniden dene",
  serverHeaderText: "Sunucu sorunu",
  serverMessageText:
    "Sunucuya bağlanırken bir sorun oluştu. Lütfen daha sonra tekrar deneyin.",
  startScreenBeginCheckText: "Canlılık kontrolüne başla",
  timeoutHeaderText: "Zaman aşımı",
  timeoutMessageText: "İşlem zaman aşımına uğradı. Lütfen tekrar deneyin.",
  tooFarAltText: "Yüz kameradan çok uzakta",
  tooFarCaptionText: "Lütfen kameraya yaklaşın.",
  tryAgainText: "Tekrar deneyin",
  waitingCameraPermissionText: "Kamera izni bekleniyor...",
};

export default tr;
